import { type ReactNode } from "react";

import { ConfirmationDialog } from "@/components/confirmation-dialog";

interface DeleteConfirmationDialogProps {
  title: string;
  description: string;
  onConfirm: () => void;
  disabled?: boolean;
  confirmLabel?: string;
  children: ReactNode;
}

export function DeleteConfirmationDialog({
  title,
  description,
  onConfirm,
  disabled,
  confirmLabel = "Delete",
  children,
}: DeleteConfirmationDialogProps) {
  return (
    <ConfirmationDialog
      title={title}
      description={description}
      onConfirm={onConfirm}
      disabled={disabled}
      confirmLabel={confirmLabel}
      confirmVariant="destructive"
    >
      {children}
    </ConfirmationDialog>
  );
}
